import { Button, Div, PopupMenu, Snack } from "@tblabs/truffle";
import { InfoFrame } from "../../../../Components/Utils/InfoFrame";
import { Order } from "../../../../Models/Order";
import { OrdersManager } from "../../../../Services/OrdersManager";
import { Router } from "../../../../Services/Router";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { Icons } from "../../../../Components/Utils/Icons";
import { XPrimaryButton } from "../../../../Components/Utils/XPrimaryButton";
import { XWarningButton } from "../../../../Components/Utils/XWarningButton";


export class OrderEditHeader extends Div
{
    private async SaveChanges()
    {
        await this._manager.Update(this.order);
        new Snack("✅ Zmiany zapisane");
        this._router.GoToOrderView(this.order.Id);
    }

    constructor(private _router: Router, private _manager: OrdersManager, private order: Order)
    {
        super("card card--spacing-bottom");

        this.Append(
            order.IsClosed && new InfoFrame("To zamówienie jest zamknięte", "Można je przywrócić z poziomu edycji"),

            new Div("card__content").Append(
                new Div("order-header__content").Append(
                    new Div("order-header__info").Append(
                        new Div("order-header__title").Text(`Zamówienie #${order.ShortId}`),
                        new Div("order-header__details").Append(
                            new Div("order-header__detail").Append(
                                new Div("order-header__detail-label").Text("Data utworzenia"),
                                new Div("order-header__detail-value").Text(order.Meta.CreatedAt.toLocaleString())
                            ),
                            new Div("order-header__detail").Append(
                                new Div("order-header__detail-label").Text("Ostatnia edycja"),
                                new Div("order-header__detail-value").Text(TimeUtils.HowLongAgo(order.Meta.UpdatedAt, "jeszcze nigdy"))
                            )
                        )
                    ),
                    new Div("order-header__actions").Append(

                        new XPrimaryButton("Zapisz zmiany", Icons.Save, async () => await this.SaveChanges()),

                        !order.IsClosed &&
                        new XWarningButton("Archiwizuj", Icons.Lock, async (btn) =>
                        {
                            try
                            {
                                if (confirm("Czy na pewno chcesz zamknąć zamówienie? Sprawdź czy wszystkie kroki zostały wykonane i czy wszystko jest rozliczone (kasa, sprzęt etc)."))
                                {
                                    btn.Disabled();
                                    await _manager.Close(order);
                                    new Snack("☑️ Zamówienie zostało zamknięte");
                                    _router.GoToOrdersList();
                                }
                            }
                            catch (ex: any)
                            {
                                new Snack(`❌ Nie udało się zamknąć zamówienia: ${ex.message}`);
                            }
                        }),

                        order.IsClosed &&
                        new XWarningButton("Przywróć", Icons.LockOpen, async (btn) =>
                        {
                            try
                            {
                                btn.Disabled();
                                await _manager.Reopen(order);
                                new Snack("☑️ Zamówienie zostało przywrócone");
                                _router.GoToOrdersList();
                            }
                            catch (ex: any)
                            {
                                new Snack(`❌ Nie udało się przywrócić zamówienia: ${ex.message}`);
                            }
                        }),

                        new PopupMenu({
                            "💕 Duplikuj": async () =>
                            {
                                const newOrder = await _manager.Duplicate(order);
                                _router.GoToOrderEdit(newOrder.Id);
                            },
                            "🥩 Edytor JSON": () => _router.GoToOrderRawEdit(order.Id),
                            "🗑️ Usuń": async () =>
                            {
                                if (confirm("Czy na pewno chcesz usunąć zamówienie? Sprawdź czy wszystkie kroki zostały wykonane i czy wszystko jest rozliczone (kasa, sprzęt etc)."))
                                {
                                    await _manager.Delete(order);
                                    new Snack("☑️ Zamówienie zostało usunięte");
                                    _router.GoToOrdersList();
                                }
                            }
                        },
                            new Button("⋮").RemoveClass("uk-button").Class("menu-button"))
                    )
                )
            )
        );
    }
}
